module.exports = __webpack_public_path__ + "static/media/notification-ask.425d9d11.png";